import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { useTranslations } from "next-intl";
import { LogoutButton } from "~/components/LogoutButton/LogoutButton";
import type { AccountMenuItem } from "../../../account/_components/layout/types";
import { MenuItemLink } from "../MobileMainMenu/MenuItemLink";

type Props = {
	items: AccountMenuItem[];
};

export const AccountMenuItems = ({ items }: Props) => {
	const t = useTranslations("AccountMenuItems");

	return (
		<>
			{items.map((item) => (
				<MenuItemLink
					key={item.href}
					label={item.label}
					link={{ url: item.href }}
					icon={item.icon}
				/>
			))}
			<LogoutButton className="flex w-full items-center gap-2 rounded-none border-b border-border py-4 text-sm text-blue-300">
				<Icon icon="logout" className="size-6 text-main" />
				{t("logout")}
			</LogoutButton>
		</>
	);
};
